import { PanelbarStructure } from "../isPanelbarDetails.js";
import { Helper } from "../../util/helper.js";
import { StringKeyDictionary } from "../../../commonInterfaces.js";
import React from "react"
export default class ArticleDetails extends React.Component<any, any> {
    private translations: StringKeyDictionary<string> = {};

    componentDidMount() {
        Helper.getTranslations(["Field.Material.artikelnummer", "Field.Material.bezeichnung"])
            .then(result => {
                if (Helper.hasValue(result)) {
                    this.translations = result.Data;
                    this.setState({});
                }
            });
    }

    render() {
        const data = this.props.data;
        return (
            <PanelbarStructure label={data.Bezeichnung} keyPropValue={data.ArtNr} iconName="fa fa-tag" url={"Parts/Edit?id=" + encodeURIComponent(data.ArtNr)}>
                <table className="templateHoverTable">
                    <tbody>
                        <tr>
                            <td>
                                <span style={{ fontWeight: "bold", marginRight: "5px" }}>{this.translations["Field.Material.artikelnummer"]}</span>
                            </td>
                            <td>
                                <span>{data.Artikelnummer}</span>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <span style={{ fontWeight: "bold" }}>{this.translations["Field.Material.bezeichnung"]}</span>
                            </td>
                            <td>
                                <span>{data.Bezeichnung}</span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </PanelbarStructure>
        );
    }
}